import { coerceArray } from '@angular/cdk/coercion';
import { EventEmitter, signal } from '@angular/core';
import { AbstractControlOptions, FormControl, FormControlState } from '@angular/forms';

const defaultControlSettings: AbstractControlOptions = { updateOn: 'change', asyncValidators: [], validators: [] };

/**
 * @description
 * an extension (inheritance) of the FormControl, to allow emission of the "statusChange" event
 * when "touched" status changes (by default "touched" changes dose not trigger status changes)
 */
export class ExtendedFormControl<T = unknown> extends FormControl<T> {
  // private _touchedEmitter: Subject<boolean> = new Subject<boolean>();
  // touchedChanges: Observable<boolean> = this._touchedEmitter.asObservable();

  markAsTouched$$ = signal<boolean>(false);

  constructor(formState: FormControlState<T>, options: AbstractControlOptions = defaultControlSettings) {
    options = {
      updateOn: options.updateOn || defaultControlSettings.updateOn,
      validators: [...coerceArray(defaultControlSettings.validators)],
      asyncValidators: [...coerceArray(defaultControlSettings.asyncValidators)]
    };

    super(formState, options);
  }

  override markAsTouched({ onlySelf }: { onlySelf?: boolean } = {}): void {
    super.markAsTouched({ onlySelf });

    this.markAsTouched$$.set(true);
    // this._touchedEmitter.next(true);
    (<EventEmitter<any>>this.statusChanges).emit(this.status);
  }
}
